/**
 * EscalationManagementPage - Escalation management
 *
 * Surfaces the EscalationManager from @ferp/workflow-forms for admin/architect users.
 * Provides full CRUD management of escalation paths and notifications.
 *
 * Route: /admin/escalation-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconBellRinging } from '@tabler/icons-react';

import { EscalationManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function EscalationManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="red">
            <IconBellRinging size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Escalation Management</Title>
            <Text size="sm" c="dimmed">
              Manage escalation paths, triggers, and notification routing
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <EscalationManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default EscalationManagementPage;
